import { Model } from '../../infra/model'
import { makeObservable, observable, computed } from 'mobx'
import { DateZero, maybeParseDate } from '../../utils/date-util'
import { addDays } from 'date-fns'
import { WorkspaceInvitationDTO } from '../workspace-postings-opportunities/dtos/workspace-posting-opportunity'
import { toStream, fromStream } from '../../utils/mobx-util'
import { switchMap } from 'rxjs/operators'
import { countdown } from '../../utils/rx-util'
import { Id } from '../../types/definitions'

export default class WorkspaceInvitation extends Model<
  WorkspaceInvitationDTO,
  WorkspaceInvitation
> {
  /**
   * An observable countdown. Ticks every second in sync with clock time until
   * the scheduled expiration time is reached.
   */
  private _timeUntilExpiration$ = toStream(() => this.dateExpires, true).pipe(
    switchMap(countdown),
  )

  /**
   * MobX-representation the time until expiration stream.
   */
  private _timeUntilExpiration = fromStream(null, this._timeUntilExpiration$)

  id: Id = Id.none
  workspaceId: string = ''
  primarySoftware: string = ''
  supplementalSoftware: string | null = null
  location: string = ''
  description: string = ''
  specialties: string[] = []
  dateCreated: Date = DateZero()
  dateModified: Date = DateZero()
  dateInvited: Date = DateZero()

  constructor() {
    super()
    makeObservable(this, {
      id: observable,
      workspaceId: observable,
      dateCreated: observable,
      dateModified: observable,
      dateInvited: observable,
      primarySoftware: observable,
      supplementalSoftware: observable,
      location: observable,
      description: observable,
      specialties: observable,
      dateExpires: computed,
      timeUntilExpiration: computed,
    })
  }

  get dateExpires() {
    return addDays(this.dateInvited, 1)
  }

  get timeUntilExpiration() {
    return this._timeUntilExpiration()
  }

  parse(attrs: WorkspaceInvitationDTO) {
    return {
      id: attrs.id,
      workspaceId: attrs.workspace_id,
      primarySoftware: attrs.primary_software,
      supplementalSoftware: attrs.supplemental_software,
      location: attrs.location,
      description: attrs.description,
      specialties: attrs.specialties,
      dateCreated: maybeParseDate(attrs.date_created),
      dateModified: maybeParseDate(attrs.date_modified),
      dateInvited: maybeParseDate(attrs.date_invited),
    }
  }
}
